module.exports = __webpack_public_path__ + "media/images/icon-mail-132530df541a67aa2329c716f253d52e.svg";